import React from 'react';
import { motion } from 'framer-motion';
import { FaHotel, FaPlaneDeparture, FaCar, FaMapMarkedAlt, FaGlassCheers, FaPray } from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const serviceList = [
    {
      id: 1,
      icon: <FaHotel />,
      title: "Comfortable Stays",
      desc: "Well-selected hotels that offer comfort, cleanliness, and great value for a pleasant and relaxing stay."
    },
    {
      id: 2,
      icon: <FaMapMarkedAlt />,
      title: "Customized Tour Planning",
      desc: "Travel plans tailored to your destination, budget, and preferences for a trip that truly suits you."
    },
    {
      id: 3,
      icon: <FaPray />,
      title: "Spiritual Tours",
      desc: "Organized spiritual journeys including Char Dham, Varanasi, Ayodhya, and other sacred destinations across India."
    },
    {
      id: 4,
      icon: <FaCar />,
      title: "Comfortable Transportation",
      desc: "Safe and reliable vehicle arrangements to ensure smooth and hassle-free travel throughout your journey."
    },
    {
      id: 5,
      icon: <FaPlaneDeparture />,
      title: "Flight Booking Assistance",
      desc: "Support with domestic and international flight bookings at competitive fares."
    },
    {
      id: 6,
      icon: <FaGlassCheers />,
      title: "Corporate & Group Travel",
      desc: "Professional travel arrangements for corporate teams, organizations, and group tours with seamless coordination."
    }
  ];

  return (
    <section className="services-section">
      <div className="container">
        {/* Header Section */}
        <div className="services-header">
          <motion.span 
            initial={{ opacity: 0, letterSpacing: "2px" }}
            whileInView={{ opacity: 1, letterSpacing: "5px" }}
            className="sub-tag"
          >
            WHAT WE OFFER
          </motion.span>
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="main-title"
          >
           
Everything You Need for a <br /> <span>Smooth & Memorable </span> Trip
          </motion.h2>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {serviceList.map((service, index) => (
            <motion.div 
              key={service.id}
              className="service-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              whileHover={{ y: -12 }}
            >
              <div className="icon-box">
                {service.icon}
              </div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              <div className="card-footer">
                {/* <span className="read-more">Learn More ➔</span> */}
              </div>
              <div className="card-bg-shape"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;